import React from 'react';

const ImageVerificationStatus = ({ imageData }) => {
    if (!imageData) return null;

    const getImageVerificationMessage = (data) => {
        const status = data.authenticity_status || "uncertain";
        const score = data.authenticity_score !== undefined ? data.authenticity_score : 0;
        const color = status === "authentic" ? "var(--success)" :
            status === "uncertain" ? "var(--warning)" : "var(--danger)";

        // Use the unified message from backend if available (syncs with WhatsApp)
        if (data.message) {
            return {
                icon: null, // Backend message already includes the emoji
                message: data.message,
                color: color
            };
        }

        // Fallback or legacy handling
        if (status === "authentic") {
            return {
                icon: "✅",
                message: `Authentic: ${score.toFixed(1)}% authenticity`,
                color: color
            };
        } else if (status === "uncertain") {
            return {
                icon: "🤔",
                message: `Uncertain: ${score.toFixed(1)}% authenticity`,
                color: color
            };
        } else {
            return {
                icon: "🚨",
                message: `Likely Manipulated: ${score.toFixed(1)}% authenticity`,
                color: color
            };
        }
    };

    const verification = getImageVerificationMessage(imageData);

    return (
        <div className="card image-verification-card">
            <h3>Image Forensics</h3>
            {imageData.image_url && (
                <div className="verified-image-wrapper">
                    <img
                        src={imageData.image_url}
                        alt="Verified Analysis"
                        className="verified-image"
                        onError={(e) => (e.target.style.display = "none")}
                    />
                    {imageData.caption && (
                        <div className="image-caption-overlay">
                            <p>{imageData.caption}</p>
                        </div>
                    )}
                </div>
            )}
            <div className="authenticity-status-modern" style={{
                backgroundColor: `${verification.color}15`,
                border: `1px solid ${verification.color}30`,
                boxShadow: `0 0 15px ${verification.color}10`,
                color: verification.color
            }}>
                {verification.icon && <span className="status-icon">{verification.icon}</span>}
                <span className="status-text">{verification.message}</span>
            </div>
        </div>
    );
};

export default ImageVerificationStatus;
